import React, { useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext";
import SuperviseurLayout from "../../components/layouts/SuperviseurLayout";
import api from "../../services/api";

// ── Modal Recharger ──
const ModalRecharger = ({ commercial, superviseurId, onClose, onSuccess }) => {
  const [montant, setMontant] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post(`/superviseurs/${superviseurId}/commerciaux/${commercial.id}/recharger`, {
        montant: parseInt(montant)
      });
      onSuccess();
    } catch (err) {
      setError(err.response?.data?.error || "Erreur lors du rechargement");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div onClick={onClose} style={{ position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.45)", zIndex: 200, display: "flex", alignItems: "center", justifyContent: "center", padding: "1rem" }}>
      <div onClick={(e) => e.stopPropagation()} style={{ backgroundColor: "white", borderRadius: "16px", padding: "1.5rem", width: "100%", maxWidth: "380px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1.25rem" }}>
          <h3 style={{ fontSize: "16px", fontWeight: "500", margin: 0 }}>Recharger {commercial.prenom} {commercial.nom}</h3>
          <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", fontSize: "20px", color: "#6b7280" }}>×</button>
        </div>
        {error && (
          <div style={{ marginBottom: "1rem", padding: "0.75rem", backgroundColor: "#fef2f2", border: "1px solid #fecaca", borderRadius: "8px", color: "#dc2626", fontSize: "13px" }}>
            {error}
          </div>
        )}
        <form onSubmit={handleSubmit}>
          <label style={{ fontSize: "12px", color: "#6b7280", display: "block", marginBottom: "6px" }}>Montant (F CFA) *</label>
          <input
            type="number" value={montant} onChange={(e) => setMontant(e.target.value)}
            placeholder="Ex: 100000" required min={1}
            style={{ width: "100%", padding: "0.75rem 1rem", border: "1px solid #e5e7eb", borderRadius: "8px", fontSize: "14px", color: "#111827", outline: "none", boxSizing: "border-box", background: "white", marginBottom: "1.25rem" }}
          />
          <button type="submit" disabled={loading} style={{ width: "100%", padding: "0.75rem", background: "linear-gradient(135deg, #0f6e56, #1D9E75)", color: "white", fontWeight: "500", fontSize: "14px", borderRadius: "9999px", border: "none", cursor: loading ? "not-allowed" : "pointer", opacity: loading ? 0.7 : 1 }}>
            {loading ? "Rechargement..." : "Recharger"}
          </button>
        </form>
      </div>
    </div>
  );
};

// ── Modal Retirer Solde (transfert vers un autre commercial) ──
const ModalRetirerSolde = ({ commercial, commerciaux, superviseurId, onClose, onSuccess }) => {
  const [montant, setMontant] = useState("");
  const [toutRetirer, setToutRetirer] = useState(true);
  const [commercialDestId, setCommercialDestId] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Commerciaux disponibles comme destinataires (exclure la source)
  const destinations = commerciaux.filter(c => c.id !== commercial.id && c.actif);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!commercialDestId) { setError("Veuillez sélectionner un commercial destinataire"); return; }
    setLoading(true);
    try {
      const body = { commercialDestId: parseInt(commercialDestId) };
      if (!toutRetirer) body.montant = parseInt(montant);
      await api.post(`/superviseurs/${superviseurId}/commerciaux/${commercial.id}/retirer-solde`, body);
      onSuccess();
    } catch (err) {
      setError(err.response?.data?.error || "Erreur lors du transfert");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div onClick={onClose} style={{ position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.45)", zIndex: 200, display: "flex", alignItems: "center", justifyContent: "center", padding: "1rem" }}>
      <div onClick={(e) => e.stopPropagation()} style={{ backgroundColor: "white", borderRadius: "16px", padding: "1.5rem", width: "100%", maxWidth: "400px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1.25rem" }}>
          <h3 style={{ fontSize: "16px", fontWeight: "500", margin: 0 }}>Transférer solde — {commercial.prenom} {commercial.nom}</h3>
          <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", fontSize: "20px", color: "#6b7280" }}>×</button>
        </div>
        <div style={{ padding: "0.75rem", backgroundColor: "#f0fdf4", borderRadius: "8px", marginBottom: "1rem", fontSize: "13px", color: "#0f6e56" }}>
          Solde disponible : <strong>{Number(commercial.solde || 0).toLocaleString("fr-FR")} F</strong>
        </div>
        {error && <div style={{ marginBottom: "1rem", padding: "0.75rem", backgroundColor: "#fef2f2", border: "1px solid #fecaca", borderRadius: "8px", color: "#dc2626", fontSize: "13px" }}>{error}</div>}
        <form onSubmit={handleSubmit}>
          <label style={{ fontSize: "12px", color: "#6b7280", display: "block", marginBottom: "6px" }}>Commercial destinataire *</label>
          <select value={commercialDestId} onChange={e => setCommercialDestId(e.target.value)} required
            style={{ width: "100%", padding: "0.65rem 0.9rem", border: "1px solid #e5e7eb", borderRadius: "8px", fontSize: "13px", outline: "none", boxSizing: "border-box", background: "white", marginBottom: "1rem" }}>
            <option value="">-- Sélectionner --</option>
            {destinations.map(c => (
              <option key={c.id} value={c.id}>{c.prenom} {c.nom} (solde : {Number(c.solde || 0).toLocaleString("fr-FR")} F)</option>
            ))}
          </select>
          <div style={{ display: "flex", gap: "12px", marginBottom: "1rem" }}>
            <label style={{ display: "flex", alignItems: "center", gap: "6px", fontSize: "13px", cursor: "pointer" }}>
              <input type="radio" checked={toutRetirer} onChange={() => setToutRetirer(true)} /> Tout transférer
            </label>
            <label style={{ display: "flex", alignItems: "center", gap: "6px", fontSize: "13px", cursor: "pointer" }}>
              <input type="radio" checked={!toutRetirer} onChange={() => setToutRetirer(false)} /> Montant partiel
            </label>
          </div>
          {!toutRetirer && (
            <input type="number" value={montant} onChange={e => setMontant(e.target.value)} placeholder="Montant à transférer" required={!toutRetirer} min={1}
              style={{ width: "100%", padding: "0.75rem 1rem", border: "1px solid #e5e7eb", borderRadius: "8px", fontSize: "14px", outline: "none", boxSizing: "border-box", background: "white", marginBottom: "1rem" }} />
          )}
          <button type="submit" disabled={loading} style={{ width: "100%", padding: "0.75rem", background: "linear-gradient(135deg, #0f6e56, #1D9E75)", color: "white", fontWeight: "500", fontSize: "14px", borderRadius: "9999px", border: "none", cursor: loading ? "not-allowed" : "pointer", opacity: loading ? 0.7 : 1 }}>
            {loading ? "Transfert..." : "Confirmer le transfert"}
          </button>
        </form>
      </div>
    </div>
  );
};

// ── Modal Créer Compte Commercial ──
const ModalCreerCommercial = ({ superviseurId, onClose, onSuccess }) => {
  const [form, setForm] = useState({ nom: "", prenom: "", email: "", produitId: "" });
  const [produits, setProduits] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get("/produits").then(r => setProduits(r.data)).catch(() => {});
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const body = { nom: form.nom, prenom: form.prenom, email: form.email, role: "Commercial" };
      if (form.produitId) body.produitId = parseInt(form.produitId);
      await api.post("/auth/creer-compte", body);
      onSuccess();
    } catch (err) {
      setError(err.response?.data?.error || "Erreur lors de la création");
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = { width: "100%", padding: "0.65rem 0.9rem", border: "1px solid #e5e7eb", borderRadius: "8px", fontSize: "13px", color: "#111827", outline: "none", boxSizing: "border-box", background: "white", marginBottom: "0.75rem" };

  return (
    <div onClick={onClose} style={{ position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.45)", zIndex: 200, display: "flex", alignItems: "center", justifyContent: "center", padding: "1rem" }}>
      <div onClick={(e) => e.stopPropagation()} style={{ backgroundColor: "white", borderRadius: "16px", padding: "1.5rem", width: "100%", maxWidth: "400px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1.25rem" }}>
          <h3 style={{ fontSize: "16px", fontWeight: "500", margin: 0 }}>Nouveau commercial</h3>
          <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", fontSize: "20px", color: "#6b7280" }}>×</button>
        </div>
        {error && <div style={{ marginBottom: "1rem", padding: "0.75rem", backgroundColor: "#fef2f2", border: "1px solid #fecaca", borderRadius: "8px", color: "#dc2626", fontSize: "13px" }}>{error}</div>}
        <p style={{ fontSize: "12px", color: "#6b7280", marginBottom: "1rem" }}>Les identifiants seront envoyés par email au commercial.</p>
        <form onSubmit={handleSubmit}>
          <label style={{ fontSize: "12px", color: "#6b7280", display: "block", marginBottom: "4px" }}>Nom *</label>
          <input value={form.nom} onChange={(e) => setForm({ ...form, nom: e.target.value })} placeholder="Diallo" required style={inputStyle} />
          <label style={{ fontSize: "12px", color: "#6b7280", display: "block", marginBottom: "4px" }}>Prénom *</label>
          <input value={form.prenom} onChange={(e) => setForm({ ...form, prenom: e.target.value })} placeholder="Ibrahima" required style={inputStyle} />
          <label style={{ fontSize: "12px", color: "#6b7280", display: "block", marginBottom: "4px" }}>Email *</label>
          <input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="ibrahima@email.com" required style={inputStyle} />
          <label style={{ fontSize: "12px", color: "#6b7280", display: "block", marginBottom: "4px" }}>Produit (optionnel — Cash24 par défaut)</label>
          <select value={form.produitId} onChange={e => setForm({ ...form, produitId: e.target.value })} style={inputStyle}>
            <option value="">Cash24 (défaut)</option>
            {produits.map(p => <option key={p.id} value={p.id}>{p.nom}</option>)}
          </select>
          <button type="submit" disabled={loading} style={{ width: "100%", padding: "0.75rem", background: "linear-gradient(135deg, #0f6e56, #1D9E75)", color: "white", fontWeight: "500", fontSize: "14px", borderRadius: "9999px", border: "none", cursor: loading ? "not-allowed" : "pointer", opacity: loading ? 0.7 : 1, marginTop: "0.5rem" }}>
            {loading ? "Création..." : "Créer le compte"}
          </button>
        </form>
      </div>
    </div>
  );
};

// ── Page principale ──
const Commerciaux = () => {
  const { utilisateur } = useAuth();
  const [commerciaux, setCommerciaux] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalRecharger, setModalRecharger] = useState(null);
  const [modalRetirerSolde, setModalRetirerSolde] = useState(null);
  const [showModalCreer, setShowModalCreer] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");

  const fetchCommerciaux = async () => {
    try {
      const res = await api.get(`/superviseurs/${utilisateur.id}/commerciaux`);
      setCommerciaux(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (utilisateur?.id) fetchCommerciaux();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [utilisateur]);

  const handleSuccess = (msg) => {
    setModalRecharger(null);
    setShowModalCreer(false);
    setSuccessMsg(msg);
    fetchCommerciaux();
    setTimeout(() => setSuccessMsg(""), 3000);
  };

  return (
    <SuperviseurLayout>
      {modalRecharger && (
        <ModalRecharger
          commercial={modalRecharger}
          superviseurId={utilisateur.id}
          onClose={() => setModalRecharger(null)}
          onSuccess={() => handleSuccess("Commercial rechargé avec succès !")}
        />
      )}
      {modalRetirerSolde && (
        <ModalRetirerSolde
          commercial={modalRetirerSolde}
          commerciaux={commerciaux}
          superviseurId={utilisateur.id}
          onClose={() => setModalRetirerSolde(null)}
          onSuccess={() => { setModalRetirerSolde(null); fetchCommerciaux(); }}
        />
      )}
      {showModalCreer && (
        <ModalCreerCommercial
          superviseurId={utilisateur.id}
          onClose={() => setShowModalCreer(false)}
          onSuccess={() => handleSuccess("Compte créé ! Les identifiants ont été envoyés par email.")}
        />
      )}

      {/* Header */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "1.25rem", flexWrap: "wrap", gap: "0.75rem" }}>
        <div>
          <h1 style={{ fontSize: "18px", fontWeight: "500", color: "#111827", margin: 0 }}>Mes commerciaux</h1>
          <p style={{ fontSize: "13px", color: "#6b7280", margin: "4px 0 0" }}>{commerciaux.length} commercial(aux)</p>
        </div>
        <button onClick={() => setShowModalCreer(true)} style={{ padding: "0.6rem 1.25rem", background: "linear-gradient(135deg, #0f6e56, #1D9E75)", color: "white", fontWeight: "500", fontSize: "13px", borderRadius: "9999px", border: "none", cursor: "pointer", display: "flex", alignItems: "center", gap: "6px" }}>
          <svg width="14" height="14" fill="none" stroke="white" strokeWidth="2.5" viewBox="0 0 24 24">
            <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
          </svg>
          Nouveau commercial
        </button>
      </div>

      {/* Message succès */}
      {successMsg && (
        <div style={{ marginBottom: "1rem", padding: "0.75rem 1rem", backgroundColor: "#f0fdf4", border: "1px solid #86efac", borderRadius: "8px", color: "#16a34a", fontSize: "13px" }}>
          {successMsg}
        </div>
      )}

      {/* Liste */}
      <div style={{ backgroundColor: "white", border: "0.5px solid #e5e7eb", borderRadius: "16px", overflow: "hidden" }}>
        {loading ? (
          <div style={{ padding: "3rem", textAlign: "center", color: "#6b7280" }}>Chargement...</div>
        ) : commerciaux.length === 0 ? (
          <div style={{ padding: "3rem", textAlign: "center" }}>
            <div style={{ fontSize: "2rem", marginBottom: "0.5rem" }}>👤</div>
            <p style={{ color: "#6b7280", fontSize: "14px" }}>Aucun commercial affecté</p>
          </div>
        ) : (
          commerciaux.map((com, i) => (
            <div key={com.id} style={{ padding: "1rem 1.25rem", borderBottom: i < commerciaux.length - 1 ? "0.5px solid #f3f4f6" : "none", display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap" }}>
              {/* Avatar */}
              <div style={{ width: "40px", height: "40px", borderRadius: "50%", backgroundColor: com.actif ? "#E1F5EE" : "#f3f4f6", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "13px", fontWeight: "500", color: com.actif ? "#0f6e56" : "#9ca3af", flexShrink: 0 }}>
                {com.nom?.charAt(0)}{com.prenom?.charAt(0)}
              </div>

              {/* Infos */}
              <div style={{ flex: 1, minWidth: "150px" }}>
                <div style={{ fontSize: "14px", fontWeight: "500", color: "#111827" }}>
                  {com.prenom} {com.nom}
                  {!com.actif && <span style={{ marginLeft: "8px", fontSize: "11px", backgroundColor: "#f3f4f6", color: "#6b7280", padding: "1px 6px", borderRadius: "4px" }}>Archivé</span>}
                </div>
                <div style={{ fontSize: "12px", color: "#6b7280", marginTop: "2px" }}>
                  Solde : {Number(com.solde || 0).toLocaleString("fr-FR")} F · {com.nombre_coupons_vendus || 0} coupon(s) · {com.clients_en_retard || 0} en retard
                </div>
              </div>

              {/* Stats */}
              <div style={{ display: "flex", gap: "1rem", flexShrink: 0 }}>
                <div style={{ textAlign: "center" }}>
                  <div style={{ fontSize: "16px", fontWeight: "500", color: "#0f6e56" }}>{com.nombre_credits_octroyes || 0}</div>
                  <div style={{ fontSize: "10px", color: "#9ca3af" }}>crédits</div>
                </div>
                <div style={{ textAlign: "center" }}>
                  <div style={{ fontSize: "16px", fontWeight: "500", color: com.clients_en_retard > 0 ? "#dc2626" : "#111827" }}>{com.clients_en_retard || 0}</div>
                  <div style={{ fontSize: "10px", color: "#9ca3af" }}>retard</div>
                </div>
              </div>

              {/* Bouton recharger */}
              {com.actif && (
                <div style={{ display: "flex", gap: "8px", flexShrink: 0 }}>
                  <button onClick={() => setModalRecharger(com)}
                    style={{ padding: "0.5rem 1rem", backgroundColor: "#E1F5EE", color: "#0f6e56", border: "none", borderRadius: "8px", fontSize: "12px", fontWeight: "500", cursor: "pointer" }}>
                    Recharger
                  </button>
                  {(com.solde || com.nombre_coupons_vendus) > 0 && (
                    <button onClick={() => setModalRetirerSolde(com)}
                      style={{ padding: "0.5rem 1rem", backgroundColor: "#fff7ed", color: "#ea580c", border: "none", borderRadius: "8px", fontSize: "12px", fontWeight: "500", cursor: "pointer" }}>
                      Retirer solde
                    </button>
                  )}
                </div>
              )}
            </div>
          ))
        )}
      </div>
    </SuperviseurLayout>
  );
};

export default Commerciaux;